/** <copy-code success-text="Copied">
  <div class="common-copy-container">
    <div class="copy-child-container">
      <span class="discount-text">CODE:</span>
      <div class="discount-code">SAVE20</div>
      <button class="copy-btn"></button>
    </div>
  </div>
</copy-code>

<copy-code success-text="Kopiert">
    <div class="coupon-container">
        <div class="coupon">
            <div class="coupon-left">
                <span class="code-text">Code:</span>
                <span class="code">26PDX50UC</span>
            </div>
            <div class="coupon-right">
                <button class="copy-btn">Kopieren</button>
            </div>
        </div>
    </div>
</copy-code> **/

if (document.querySelector("copy-code")) {
  if (!customElements.get("copy-code")) {
    class CopyCode extends HTMLElement {
      constructor() {
        super();

        this.successText =
          this.getAttribute("success-text") || "Kopiert";

        this.render();
        this.bindEvents();
      }

      render() {
        if (!document.querySelector("#copy-code-style")) {
          const style = document.createElement("style");

          style.id = "copy-code-style";

          style.textContent = `
            .copy-success-text {
              display:flex;
              gap:12px;
              color:#000;
              align-items:center;
              font-family:var(--misanslatin-demibold);
              font-size:clamp(14px,1.5vw,18px);
              position:fixed;
              top:15%;
              left:0;
              right:0;
              width:fit-content;
              margin:auto;
              box-shadow:0 0 8px #00000040;
              background:#fff;
              border-radius:12px;
              padding:12px 24px;
              z-index:999999;
            }

            .copy-success-text::before {
              content:'';
              background:url(https://cdn.shopify.com/s/files/1/0584/7508/6033/files/copy-code-arrow.png?v=1763030071)
                center/contain no-repeat;
              width:24px;
              height:24px;
              background-size:10px 7px;
              background-color:#4CB414;
              border-radius:50%;
            }

            .card-product-3 .card-product-3__image-container .common-copy-container{
              justify-content:center;
            }
          `;

          document.head.appendChild(style);
        }

        /*
         * 兼容旧版结构
         * 自动生成 copy-btn
         */
        const oldContainer = this.querySelector(
          ".copy-child-container"
        );

        if (
          oldContainer &&
          !oldContainer.querySelector(".copy-btn")
        ) {
          const btn = document.createElement("button");

          btn.classList.add("copy-btn");

          oldContainer.appendChild(btn);
        }

        this.parentElement?.classList.add(
          "card-copy-container"
        );
      }

      bindEvents() {
        const copyBtn = this.querySelector(".copy-btn");

        if (!copyBtn) return;

        copyBtn.addEventListener("click", async (event) => {
          event.preventDefault();
          event.stopPropagation();

          /*
           * 同时支持：
           * .discount-code
           * .code
           */
          const codeEl =
            this.querySelector(".discount-code") ||
            this.querySelector(".code");

          const content =
            codeEl?.textContent?.trim();

          if (!content) return;

          try {
            /*
             * 优先使用现代 API
             */
            if (
              navigator.clipboard &&
              window.isSecureContext
            ) {
              await navigator.clipboard.writeText(
                content
              );
            } else {
              /*
               * fallback
               */
              const input =
                document.createElement("input");

              input.value = content;

              document.body.appendChild(input);

              input.select();

              document.execCommand("copy");

              input.remove();
            }

            this.showSuccess();

            /*
             * 自动挂折扣
             */
            fetch(
              `/discount/${encodeURIComponent(content)}`
            ).catch(() => {});
          } catch (err) {
            console.error(
              "Copy code failed:",
              err
            );
          }
        });
      }

      showSuccess() {
        const successEl =
          document.createElement("div");

        successEl.className =
          "copy-success-text";

        successEl.textContent =
          this.successText;

        document.body.appendChild(successEl);

        setTimeout(() => {
          successEl.remove();
        }, 1000);
      }
    }

    customElements.define(
      "copy-code",
      CopyCode
    );
  }
}